import { Component, Inject, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import AccountService from '@/account/account.service';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import { BModal } from 'bootstrap-vue';
import VerificacionService from '@/entities/seguimiento/verificacion.service';
import { FiltroVerificaciones } from '@/shared/model/filtro-verificaciones.model';
import { EstadoVerificacion } from '@/shared/model/enumerations/estado-verificacion';
import * as mesUtils from '@/shared/date/mes-utils';
import { Verificacion, PeriodoVerificacion } from '@/shared/model/seguimiento/verificacion/verificacion.model';

@Component({
  computed: {
    userCvu: {
      get() {
        return this.$store.getters.userInfo?.cvu;
      },
    },
  },
})
export default class HomeMenuComponent extends Vue {
  @Inject('accountService') private readonly accountService!: () => AccountService;
  @Inject('personalBecaService') private readonly personalBecaService!: () => PersonalBecaService;
  @Inject('verificacionService') private readonly verificacionService!: () => VerificacionService;

  @Prop({ default: null })
  public value: string;

  @Ref('seguimientoCoordinador')
  public readonly seguimientoCoordinadorModal: BModal;

  private hasAnyAuthorityValues = {};

  private readonly accesoPermisos = {
    permiteConsultaSolicitudes: [
      RolAutoridad.COORDINADOR_PROGRAMA,
      RolAutoridad.COORDINADOR_INSTITUCIONAL,
      RolAutoridad.ASISTENTE_COORDINADOR,
      RolAutoridad.ASISTENTE_COORDINADOR_INSTITUCIONAL,
    ],
  };
  public rol: RolAutoridad;
  public permiteConsultaSolicitudes = false;
  public filtroVerificaciones = new FiltroVerificaciones();
  public readonly userCvu!: string;
  public clavesProgramas: string[] = [];

  /**
   * Día límite para realizar el proceso de verificación de becarios
   */
  public readonly fechaCorteVerificacion = 10;

  /**
   * Valida que la verificación de becarios se encuentra activa y mostrar modal con mensaje a los coordinadores de programas en BN
   */
  public isPeriodoValido = false;
  public mesesPendientes = [];
  public verificacion: Array<Verificacion> = [];
  public periodosVerificacion: Array<PeriodoVerificacion> = [];
  public mesUtils = mesUtils;

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public mounted(): void {
    this.personalBecaService()
      .find(true, null)
      .then(res => {
        this.rol = res.rol;
        this.clavesProgramas = res.programaClaves;
        for (const permiso in this.accesoPermisos) {
          this[permiso] = this.accesoPermisos[permiso].includes(this.rol);
        }
        if (this.permiteConsultaSolicitudes) {
          this.obtenerVerificaciones();
        }
      })
      .catch(error => {
        this.rol = null;
        this.permiteConsultaSolicitudes = false;
      });

    const fechaActual = new Date();
    const diaActual = fechaActual.getDate();
    this.isPeriodoValido = diaActual <= this.fechaCorteVerificacion;
  }

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        if (this.hasAnyAuthorityValues[authorities] !== value) {
          this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
        }
      });
    return this.hasAnyAuthorityValues[authorities] ?? false;
  }

  get isStaff() {
    return this.hasAnyAuthority(['ROLE_OPERADOR', 'ROLE_SOPORTE', 'ROLE_AUDITOR']);
  }

  @Watch('userCvu')
  @Watch('permiteConsultaSolicitudes')
  public obtenerVerificaciones(): void {
    if (this.userCvu && this.permiteConsultaSolicitudes) {
      if (this.rol === RolAutoridad.ASISTENTE_COORDINADOR) {
        this.filtroVerificaciones.clavesProgramas = this.clavesProgramas;
        this.filtroVerificaciones.estadoActual = EstadoVerificacion.PENDIENTE;
      } else {
        this.filtroVerificaciones.cvuCoordinador = this.userCvu;
        this.filtroVerificaciones.estadoActual = EstadoVerificacion.PENDIENTE;
      }

      const paginationQuery = {
        page: 0,
        size: 10,
        sort: ['id , desc'],
        filter: this.filtroVerificaciones,
      };

      this.verificacionService()
        .obtenerVerificaciones(paginationQuery)
        .then(res => {
          if (res?.data.length > 0 && this.isPeriodoValido) {
            this.seguimientoCoordinadorModal.show();
            this.verificacion = res.data;
            this.periodosVerificacion = mesUtils.agruparMesAnio(res.data);
          }
        })
        .catch(error => {});
    }
  }

  public hideModalseguimientoCoordinador(): void {
    this.seguimientoCoordinadorModal.hide();
  }
}
